module.exports = __webpack_public_path__ + "assets/img/diagram03.c070b541.svg";